import { Link } from "react-router-dom";

const shortcuts = [
  {
    to: "/category?type=电影",
    icon: "ri-film-line",
    label: "电影",
    desc: "夜勤题材院线作品",
    tones: "bg-primary-100 text-primary-700",
  },
  {
    to: "/category?type=电视剧",
    icon: "ri-tv-2-line",
    label: "电视剧",
    desc: "季播剧集与单元剧",
    tones: "bg-accent-100 text-accent-700",
  },
  {
    to: "/search?category=资讯",
    icon: "ri-newspaper-line",
    label: "最新资讯",
    desc: "快讯、剧情解析与专题",
    tones: "bg-secondary-200 text-secondary-900",
  },
];

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
      {shortcuts.map((item) => (
        <Link
          key={item.label}
          to={item.to}
          className="group flex items-center gap-4 p-4 md:p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
        >
          <span className={`w-12 h-12 shrink-0 rounded-lg flex items-center justify-center ${item.tones}`}>
            <i className={`${item.icon} text-2xl`}></i>
          </span>
          <span className="min-w-0 flex-1">
            <span className="block font-heading font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
              {item.label}
            </span>
            <span className="block text-xs text-foreground-500 mt-0.5">{item.desc}</span>
          </span>
          <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-0.5 transition-all"></i>
        </Link>
      ))}
    </div>
  );
}